import { AsyncEngine, ownTaskFilter, subscriptionTaskFilter, unknownTaskFilter } from "@chorda/core";
import { createVNode, render } from "inferno";
class InfernoRenderer extends AsyncEngine {
    constructor() {
        super();
        this.roots = [];
    }
    attach(el, node) {
        this.roots.push({ el, node });
    }
    detach(node) {
        this.roots = this.roots.filter(root => root.node != node);
        // TODO render(null, el)
    }
    schedule() {
        this.scheduled = true;
        requestAnimationFrame(() => {
            console.log('[inferno] render start', this.roots.length);
            //if (this.roots.length == 0) return
            this.scheduled = false;
            this.processing = true;
            let tasks = this.tasks;
            this.tasks = [];
            const rendered = this.roots.map(root => root.node.render(true));
            this.roots.forEach((root, i) => {
                render(rendered[i], root.el, () => {
                    //                    console.log('[inferno] dom ready')
                    tasks
                        .filter(ownTaskFilter(this))
                        .filter(subscriptionTaskFilter(this.subscriptions))
                        .filter(unknownTaskFilter(this.subscriptions));
                    console.log('[inferno] render end');
                });
            });
            if (this.roots.length == 0) {
                console.log('[inferno] render end. no registered roots');
            }
            this.processing = false;
        });
    }
    get events() {
        return {};
    }
    isAttached(node) {
        return this.roots.find((root) => root.node == node) != null;
    }
    createVNode(key, vnodeProps, dom, children) {
        const props = Object.assign(Object.assign({}, vnodeProps), { key, style: dom.styles });
        let ref = null;
        if (dom.$isSubscribed) {
            let f = domMap.get(dom);
            if (f == null) {
                f = (el) => dom.$publish(el);
                domMap.set(dom, f);
            }
            ref = f; //(el: HTMLElement) => dom.$publish(el)
        }
        if (dom.html) {
            props.dangerouslySetInnerHTML = { __html: dom.html };
            //return createTextVNode(dom.html, dom.key as any)
        }
        return createVNode(1 /* HtmlElement */, dom.tag || 'div', dom.className, children, 0 /* UnknownChildren */, props, dom.key, ref);
    }
}
export const createInfernoRenderer = () => {
    return new InfernoRenderer();
};
const domMap = new WeakMap();
// export const defaultVNodeFactory = <P, O extends HtmlProps>(key: string, vnodeProps: P, dom: O&Dom&Observable<HTMLElement>, children: any[]) => {
//     const props = {
//         ...vnodeProps
//     }
//     let ref: Ref = null
//     if (dom.$isSubscribed) {
//         let f = domMap.get(dom)
//         if (f == null) {
//             f = (el: HTMLElement) => dom.$publish(el)
//             domMap.set(dom, f)
//         }
//         ref = f as Ref//(el: HTMLElement) => dom.$publish(el)
//     }
//     return createVNode(VNodeFlags.HtmlElement, (dom.tag as any) || 'div', dom.className, children, ChildFlags.UnknownChildren, props, dom.key as any, ref)
// }
